/* eslint-disable react/no-array-index-key */

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Circle,
  Flex,
  Grid,
  GridItem,
  HStack,
  Slider,
  SliderFilledTrack,
  SliderTrack
} from "@chakra-ui/react";
import _ from "lodash";
import { ReactNode, useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { setTimeout } from "timers";

import { useInterval } from "src/hooks";

type SwipeableProps = {
  showPercent?: boolean;
  showSlider?: boolean;
  isAuto?: boolean;
  itemsToShow?: number;
  spacing?: number;
  isDirection?: boolean;
  children: ReactNode;
  customSliderDotProps?: (currentIndex: number, activeIndex: number) => any;
  customSliderProps?: any;
  [wrapperStyle: string]: any;
  dotColor?: string;
  isManualAuto?: boolean;
  customNextButtonProps?: any;
  customPrevButtonProps?: any;
  activeIdx?: number;
  callbackFunc?: () => void;
  isDirectionButtonsOverlap?: boolean;
  wrapperStyle?: any;
};

const Swipeable = ({
  showPercent = true,
  showSlider = false,
  itemsToShow = 1,
  children,
  spacing = 2,
  isAuto = false,
  isDirection = false,
  customSliderDotProps = () => null,
  customSliderProps = {},
  customNextButtonProps = {},
  customPrevButtonProps = {},
  wrapperStyle,
  dotColor = "primary.300",
  isManualAuto = false,
  isDirectionButtonsOverlap = false,
  activeIdx,
  callbackFunc,
  ...props
}: SwipeableProps) => {
  const [percent, setPercent] = useState(20);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const index = Math.floor(activeIdx / itemsToShow);
    const timeout = index === activeIndex ? 0 : 800;
    if (activeIdx || activeIdx === 0) {
      setActiveIndex(index);
      setTimeout(callbackFunc, timeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIdx]);

  useEffect(() => {
    setPercent((itemsToShow * (activeIndex + 1) * 100) / 5);
  }, [activeIndex, itemsToShow]);

  useInterval(() => {
    if (isManualAuto)
      // eslint-disable-next-line no-unsafe-optional-chaining
      setActiveIndex((currentActiveIndex) =>
        currentActiveIndex === pages?.length - 1 ? 0 : currentActiveIndex + 1
      );
  }, 3000);

  if (!children) return null;

  if (!_.isArray(children)) {
    return (
      <Flex width="100%">
        <Box flex="1">{children}</Box>
      </Flex>
    );
  }

  const pages = _.chunk(children, itemsToShow);

  const MainSwipeable = isAuto ? autoPlay(SwipeableViews) : SwipeableViews;

  const handleChangeSlide = (direction) => {
    if (direction === "prev" && activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }

    if (direction === "next" && pages.length > activeIndex + 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  return (
    <Box position="relative" {...props}>
      {isDirection && (
        <Box>
          <Button
            className="nextSwipeable"
            position="absolute"
            boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)"
            top={["calc(50% - 11px)", "calc(50% - 12px)"]}
            right={isDirectionButtonsOverlap ? "-30px" : ["0", "-48px"]}
            zIndex="1"
            background="white"
            color="primary.500"
            _hover={{ color: "primaryTwo.500", background: "white" }}
            fontSize={["22px", "24px"]}
            borderRadius="50%"
            width={["35px", "37px"]}
            {...customNextButtonProps}
            onClick={() => handleChangeSlide("next")}
          >
            <ChevronRightIcon />
          </Button>
          <Button
            className="prevSwipeable"
            position="absolute"
            boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)"
            top={["calc(50% - 11px)", "calc(50% - 12px)"]}
            left={isDirectionButtonsOverlap ? "-30px" : ["0", "-48px"]}
            zIndex="1"
            background="white"
            color="primary.500"
            _hover={{ color: "primaryTwo.500", background: "white" }}
            fontSize={["22px", "24px"]}
            borderRadius="50%"
            width={["35px", "37px"]}
            {...customPrevButtonProps}
            onClick={() => handleChangeSlide("prev")}
          >
            <ChevronLeftIcon />
          </Button>
        </Box>
      )}

      <Box {...wrapperStyle}>
        <MainSwipeable
          index={activeIndex}
          onChangeIndex={setActiveIndex}
          enableMouseEvents={!activeIdx && activeIdx !== 0}
          slideStyle={{
            backgroundColor: "default.100",
            border: 0,
            boxShadow: "none",
            paddingBottom: 10
          }}
          style={{ backgroundColor: "default.100" }}
          springConfig={{
            duration: "0.8s",
            easeFunction: "cubic-bezier(0.15, 0.3, 0.25, 1)",
            delay: "0s"
          }}
        >
          {pages.map((d, pi) => (
            <Grid templateColumns={`repeat(${itemsToShow}, 1fr)`} key={pi}>
              {d.map((item, index) => (
                <GridItem key={`grid-item-${index.toLocaleString()}`}>
                  <Box
                    mr={index !== d.length - 1 ? spacing / 2 : 0}
                    ml={index !== 0 ? spacing / 2 : 0}
                    h="100%"
                  >
                    {item}
                  </Box>
                </GridItem>
              ))}
            </Grid>
          ))}
        </MainSwipeable>
        {showPercent && (
          <Box className="hide-sm">
            <Slider aria-label="slider-ex-4" defaultValue={30} value={percent} size="md">
              <SliderTrack bg="default.200">
                <SliderFilledTrack bg="primary.500" />
              </SliderTrack>
            </Slider>
          </Box>
        )}

        {showSlider && (
          <HStack justify="center" spacing="2" mt="8" {...customSliderProps}>
            {pages.map((d, i) => (
              <Circle
                key={`testimonials_evals_${i}`}
                opacity={i === activeIndex ? 1 : 0.5}
                w={2}
                h={2}
                cursor="pointer"
                bg={dotColor}
                {...customSliderDotProps(i, activeIndex)}
                onClick={() => setActiveIndex(i)}
              />
            ))}
          </HStack>
        )}
      </Box>
    </Box>
  );
};

export default Swipeable;
